import { Component, OnInit } from '@angular/core';
import { ActivationRequest, VerifiedStatus } from 'src/app/models/account';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-submit-activation',
  templateUrl: './submit-activation.component.html',
  styleUrls: ['./submit-activation.component.css']
})
export class SubmitActivationComponent implements OnInit {

  data: ActivationRequest = new ActivationRequest();
  filename: string;
  fileURL: any;
  failMessage: string;
  message = 'Akun anda belum diaktivasi. Silahkan lakukan aktivasi akun terlebih dahulu!';
  unverifyStatus = false;

  constructor(private router: Router,
    private authService: AuthenticationService) { }

  ngOnInit() {
    const remarks = this.authService.getRemarksActivation(
      (data) => {
        if (data.data !== '') {
          console.log(data.data);
          this.message = data.data;
          this.unverifyStatus = true;
        }
      },
      err => {
        console.log(err);
      });
  }
  onFileChanged(files: FileList): void {
    if (files.length > 0) {
      const file = files.item(0);
      this.filename = file.name;
      this.data.IdentityCardFile = file;
      var mimeType = files[0].type;
      if (mimeType.match(/image\/*/) != null) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this.fileURL = reader.result;
        }
      }
    }
  }
  submit(isValid: boolean) {
    if (isValid) {
      this.authService.submitActivation(this.data,
        resp => {
          if (resp.alert.code == 200) {
            this.authService.logout();
            $('#success').modal('show');
            setTimeout(() => {
              $('#success').modal('hide');
              this.router.navigate(['/']);
            }, 2000);
          } else {
            this.failMessage = resp.alert.message;
            $('#fail').modal('show');
          }
        },
        err => {
          this.failMessage = err;
          $('#fail').modal('show');
        });
    }
  }
  backToLogin() {
    this.authService.logout();
    $('#alert').modal('hide');
    this.router.navigate(['/']);
  }

}
